import { render } from "./SnailVideosView.vue?vue&type=template&id=5a3a20e2&scoped=true"
import script from "./SnailVideosView.vue?vue&type=script&lang=js"
export * from "./SnailVideosView.vue?vue&type=script&lang=js"

import "./SnailVideosView.vue?vue&type=style&index=0&id=5a3a20e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3a20e2"]])

export default __exports__